import { Grid } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import IGridComponent from '../../../components/grid/i-grid.component';
import { isNotEmptyArray } from '../../common/util.services';
import SelectProductComponent from '../../enquiry/enq-product/select-product.component';

const AmzVirtualProductDetail = (props: any) => {
  const [open, setOpen] = useState(false);
  const rows: GridRowsProp = [];
  const [productDetail, setProductDetail] = useState(rows);

  const columns: GridColDef[] = [
    { field: 'serial', headerName: '#', filterable: false, editable: false, sortable: false, width: 5 },
    { field: 'sku', headerName: 'SKU', filterable: false, editable: false, sortable: false, width: 250 },
    { field: 'product', headerName: 'Product', filterable: false, editable: false, sortable: false, width: 320 },
    { field: 'color', headerName: 'Color', filterable: false, editable: false, sortable: false, width: 250 },
    { field: 'size', headerName: 'Size', filterable: false, editable: false, sortable: false, width: 250 },
    { field: 'unitCount', headerName: 'Pack', filterable: false, editable: false, sortable: false, width: 90 },
    { field: 'price', headerName: 'Price', filterable: false, editable: false, sortable: false, width: 90 }
  ];

  useEffect(() => {
    if (isNotEmptyArray(props.productDetail)) {
      setProductDetail(updateSerialNumber([...props.productDetail]));
    }
  }, [props.productDetail]);

  const openProductPopup = (params: any) => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const updateSerialNumber = (updatedRow: any) => {
    if (isNotEmptyArray(updatedRow)) {
      updatedRow.forEach((element: any, index: number) => {
        element.serial = index + 1;
      });
    }
    return updatedRow;
  }

  function isProductPresent(data: any) {
    for(let i = 0; i < productDetail.length; ++i) {
      if(productDetail[i].sku === data.sku) {
        return true;
      }
    }

    return false;
  }

  const onRowSelection = (selectedRows: any) => {
    setOpen(false);
    let updatedRow = [...productDetail];
    for(let i = 0; i < selectedRows.length; ++i) {
      if(!isProductPresent(selectedRows[i])) {
        selectedRows[i].unitCount = selectedRows[i].pack;
        updatedRow.push(selectedRows[i]);
      }
    }
    updatedRow = updateSerialNumber(updatedRow);
    setProductDetail(updatedRow);
    if (props.onRowSelection) {
      props.onRowSelection(updatedRow);
    }
  }

  const handleDeleteAction = (row: any) => {
    const updatedRows = productDetail.filter((r) => !(r.sku === row.sku));
    const serialRows = updateSerialNumber(updatedRows);
    setProductDetail(serialRows);
    if (props.onRowDelete) {
      props.onRowDelete(serialRows);
    }
  }

  return (
    <div>
      <Grid container spacing={1}>
        <IGridComponent title='Product Detail' rows={productDetail} columns={columns} getRowId={(row: any) => row.sku}
          apiRef={props.apiRef} showAction={true} handleDeleteAction={handleDeleteAction} showEditAction={false}
          showAddBtn={true} showApproveAction={false} addRow={openProductPopup} hideFooterPagination={true} hideFooter={false}/>
      </Grid>
      <IDialogComponent onClose={handleClose} open={open} title='Select Product' 
        dialogBody={<SelectProductComponent onRowSelection={onRowSelection} />} />
    </div>
  );
}

export default AmzVirtualProductDetail;
